import { render, staticRenderFns } from "./devicePandian.vue?vue&type=template&id=244351a8&scoped=true&"
import script from "./devicePandian.vue?vue&type=script&lang=js&"
export * from "./devicePandian.vue?vue&type=script&lang=js&"
import style0 from "./devicePandian.vue?vue&type=style&index=0&id=244351a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244351a8",
  null
  
)

export default component.exports